module.exports = __webpack_public_path__ + "static/illuminoceanpreview-b22ae21da08224937efe3d0a549fd407.jpg";